import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "setion_display_box setion_jaNavBoxBgColor_blue section_navPadding section_navFixedTop",
  style: {"justify-content":"space-between"}
}
const _hoisted_2 = {
  class: "setion_display_box section_horizon_box",
  style: {"margin-left":"2%","justify-content":"space-between"}
}
const _hoisted_3 = { class: "NavLogoImgBox" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "NavLogoTitleTextBox section_horizon_box",
  style: {"width":"90%","text-align":"left"}
}
const _hoisted_6 = { class: "p_navTitleFont" }
const _hoisted_7 = {
  class: "setion_display_box",
  style: {"justify-content":"flex-end","margin-right":"2%"}
}
const _hoisted_8 = {
  key: 0,
  class: "versionUpdateNotice",
  role: "status"
}
const _hoisted_9 = {
  class: "navAvgBox section_horizon_box",
  style: {"width":"5rem","margin-right":"2%","display":"flex","align-items":"center"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  class: "navAvgBox section_horizon_box",
  style: {"text-align":"center","color":"white","width":"-webkit-fill-available"}
}
const _hoisted_12 = { class: "p_navUserNameFont" }
const _hoisted_13 = {
  class: "navAvgBox section_horizon_box",
  style: {"text-align":"left","margin-left":"2%"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("登出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          style: {"width":"3rem","height":"3rem","border-radius":"100%"},
          src: 
            _ctx.systemConfig.clientIcon?.length > 0
              ? _ctx.systemConfig.clientIcon
              : 'https://firebasestorage.googleapis.com/v0/b/vegshipping-fatty.appspot.com/o/JD_logo%E7%99%BD2.png?alt=media&token=e374a58a-3fc2-4645-a8c2-98878c647ac2'
          
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.clientName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.appUpdateAvailable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "versionUpdateBtn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateApp && _ctx.updateApp(...args)))
            }, " 版本可以更新 ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("img", {
          class: "img_circle",
          style: {"width":"100%"},
          src: _ctx.userData.userAvatar
        }, null, 8, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.userData.userName), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_button, {
          type: "primary",
          class: "logoutBtn",
          size: "small",
          onClick: _ctx.open
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}